import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "FullScreenExit.svg",
  "use": "FullScreenExit.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"FullScreenExit.svg\"><path d=\"M57.0208,48.0208h-4v4a2,2,0,0,1-4,0v-6a2,2,0,0,1,2-2h6a2,2,0,0,1,0,4Zm0-28h-6a2,2,0,0,1-2-2v-6a2,2,0,0,1,4,0v4h4a2,2,0,0,1,0,4Zm-46-8a2,2,0,0,1,4,0v6a2,2,0,0,1-2,2h-6a2,2,0,0,1,0-4h4Zm-4,32h6a2,2,0,0,1,2,2v6a2,2,0,0,1-4,0v-4h-4a2,2,0,0,1,0-4Zm11.5-2a1.5,1.5,0,0,1-1.5-1.5v-17a1.5,1.5,0,0,1,1.5-1.5h27a1.5,1.5,0,0,1,1.5,1.5v17a1.5,1.5,0,0,1-1.5,1.5Z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol